import React from 'react'
import { Skeleton } from 'antd'

import styles from '../CO7Page.module.css'

const CollectionCardSkeleton = ({ index = 0 }) => {
    const titleWidth = ['72%', '58%', '64%', '68%'][index % 4]
    const descWidth1 = ['100%', '92%', '96%', '88%'][index % 4]
    const descWidth2 = ['78%', '84%', '70%', '82%'][index % 4]

    return (
        <article
            className={`${styles.collectionCard} ${styles.collectionCardSkeleton}`}
            aria-hidden
        >
            <div className={styles.collectionCardTop}>
                <Skeleton.Button
                    active
                    className={styles.skeletonIconWrap}
                />
                <div className={styles.collectionCardActions}>
                    <Skeleton.Button
                        active
                        className={styles.skeletonOwnerBadge}
                    />
                    <Skeleton.Button
                        active
                        className={styles.skeletonMenuBtn}
                    />
                </div>
            </div>

            <div className={styles.skeletonCardBody}>
                <Skeleton.Input
                    active
                    size="small"
                    className={styles.skeletonTitle}
                    style={{ width: titleWidth, height: 16 }}
                />
                <Skeleton.Input
                    active
                    size="small"
                    className={styles.skeletonDescription}
                    style={{ width: descWidth1, height: 13 }}
                />
                <Skeleton.Input
                    active
                    size="small"
                    className={styles.skeletonDescription}
                    style={{ width: descWidth2, height: 13 }}
                />
            </div>

            <div className={styles.collectionCardFooter}>
                <div className={styles.skeletonMemberAvatars}>
                    <Skeleton.Avatar active size={36} />
                    <Skeleton.Avatar active size={36} />
                    <Skeleton.Avatar active size={36} />
                </div>
                <Skeleton.Input
                    active
                    size="small"
                    className={styles.skeletonMemberCount}
                    style={{ width: 56, height: 12 }}
                />
            </div>
        </article>
    )
}

export default CollectionCardSkeleton
